import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import { usePrefetchComprehensiveReport } from "services/hooks/rentals";
import ComprehensiveReport from "./ComprehensiveReport";
import LandlordPayoutReport from "./LandlordPayoutReport";
import ExpensesReport from "./ExpensesReport";

const REPORT_TAB = { COMPREHENSIVE: "comprehensive", LANDLORD_PAYOUTS: "landlord_payouts", EXPENSES: "expenses" };

const Reports = () => {
  const [reportType, setReportType] = useState(REPORT_TAB.COMPREHENSIVE);
  const reportsCache = useSelector((state) => state.reportsCache);
  const needsFallbackFetch =
    reportType === REPORT_TAB.COMPREHENSIVE &&
    !reportsCache?.hasFetched &&
    !reportsCache?.isLoading;

  // Only if background prefetch has not started/finished yet (e.g. user opened Reports immediately).
  usePrefetchComprehensiveReport({
    enabled: needsFallbackFetch,
    waitForCritical: false,
    deferMs: 0,
  });

  return (
    <Box m="20px">
      <Typography variant="h4" sx={{ mb: 2 }}>
        Reports
      </Typography>
      <Tabs value={reportType} onChange={(_, v) => setReportType(v)} sx={{ mb: 3 }}>
        <Tab value={REPORT_TAB.COMPREHENSIVE} label="Comprehensive" />
        <Tab value={REPORT_TAB.LANDLORD_PAYOUTS} label="Landlord Payouts" />
        <Tab value={REPORT_TAB.EXPENSES} label="Expenses" />
      </Tabs>
      {reportType === REPORT_TAB.COMPREHENSIVE && <ComprehensiveReport />}
      {reportType === REPORT_TAB.LANDLORD_PAYOUTS && <LandlordPayoutReport />}
      {reportType === REPORT_TAB.EXPENSES && <ExpensesReport />}
    </Box>
  );
};

export default Reports;
